<template lang="html">
<div>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 sm10 md9 lg7 xl5>
          <v-container :class="{ descriptionContainer: !mobile }">
          <v-img
            :src="workPhoto"
            max-height="250"
            contain
          >
          </v-img>

          <div class="text-container">
            <h1 class="working-title text-xs-left">Working at KSG</h1>
            <p class="text-xs-left">KSG believes in providing the best tools and work environment for associates, so that they are only limited by their own abilities.</p>
            <p class="text-xs-left">We have an innovative and experienced team who specialize in areas such as game development / design, math modeling, illustration/animation (2D &amp; 3D), music composition, sound effects, voice recording, software engineering, game production and legal (trademark &amp; patent).</p>
          </div>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>

  <v-layout>
    <v-flex class="items-container">
      <v-container justify-center class="inner-items-container">
        <v-flex xs12 sm8 md8 lg6 xl5 :class="{ orderItemsContainer: !mobile }">
          <div class="item-container ">
            <v-img
              :src="iconTest"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Testing facility</h2>
              <p>State-of-art machines to ensure our games are being tested every step of the way to produce the best results</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconCompensation"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Compensation/Benefits</h2>
              <p>Competitive salaries, bonus incentives and a full range of comprehensive benefits</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconTools"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">The right tools</h2>
              <p>Powerful workstations loaded with premium animation and engineering software</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconTeam"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Strong team</h2>
              <p>Various team-building events throughout the year to help create community and fun at the office</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconHours"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Flexible work</h2>
              <p>We are supportive of individual associate needs and will accommodate remote work and  different work hour schedules</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconCulture"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Company culture</h2>
              <p>A friendly and relaxed environment that fosters personal development and teamwork</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconWellness"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Associate wellness</h2>
              <p>Ergonomic desks and chairs to support your health and maximize your comfort and productivity</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconSnacks"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Free snacks &amp; drinks</h2>
              <p>A broad selection of sparkling waters, juices and sodas along with coffee, tea and treats.</p>
            </div>
          </div>
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>

  <!-- For the employee quotes and cards -->
  <v-container justify-center wrap fluid class="career-container">
    <v-layout justify-center wrap>
      <v-flex xs12 sm8 md8 lg6 xl8>
        <h6 class="career-title">What our team is saying...</h6>
      </v-flex>

      <v-flex xs12 sm12 md10 lg8 xl6 v-if="!mobile">
        <v-container class="carousel-container">
          <font-awesome-icon icon="chevron-left" size="4x" @click="carouselLeftClick" id="carouselLeft" style="margin-right: 1rem;" />
          <v-card v-for="(employee, i) in employees" :key="i" height="500" v-if="currentCard === i" style="display: flex;">
            <v-container fluid class="employee-container">
              <v-img :src="employee.image" :key="i" aspect-ratio="1" contain></v-img>

              <v-card-text class="title font-weight-bold employee-quotes text-xs-left">
                <i style="line-height: 1.25;">"{{ employee.quote }}"</i>
                <br><br>
                <span class="name-color">~ {{ employee.name }} <span class="role-color">&nbsp;{{ employee.role }}</span></span>
              </v-card-text>
            </v-container>
          </v-card>
          <font-awesome-icon icon="chevron-right" size="4x" @click="carouselRightClick" id="carouselRight" style="margin-left: 1rem;" />
        </v-container>
      </v-flex>

      <v-flex xs12 sm8 v-else>
        <!-- <font-awesome-icon icon="chevron-left" size="2x" @click="carouselLeftClick" id="carouselLeft" style="margin-right: 1rem;" /> -->
        <v-card v-for="(employee, i) in employees" :key="i" v-if="currentCard === i">
          <v-img :src="employee.imageSquare" :key="i" aspect-ratio="1" max-height="400" contain></v-img>

          <v-card-text class="title font-weight-bold employee-quotes text-xs-left" style="position: relative;">
            <font-awesome-icon icon="chevron-left" size="3x" @click="carouselLeftClick" id="carouselLeft" class="carouselDirection" />
            <font-awesome-icon icon="chevron-right" size="3x" @click="carouselRightClick" id="carouselRight" class="carouselDirectionRight" />
            <i class="quote-style">"{{ employee.quote }}"</i>
            <br><br>
            <span class="name-color">~ {{ employee.name }} <span class="role-color">&nbsp;{{ employee.role }}</span></span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- Work hard play harder section -->
  <v-layout class="items-container">
    <v-flex>
      <v-container justify-center>
        <v-layout justify-center>
          <v-flex xs12 sm8 md8 lg6 class="text-xs-left lastContainer" v-if="!mobile">
            <div>
              <h1 id="workTitle">Work hard,<br>play harder</h1>
              <p>In addition to competitive salaries and a full range of comprehensive benefits, KSG offers benefits such as One-on-One Anniversary Lunch, Corporate Wellness Partnership with the Twin Cities Metro YMCA, Summer Event, Monthly Company Lunch to Celebrate Associate Birthdays, Annual Movie Day and More!</p>
              <!-- <v-btn round outline color="#335091" class="text-capitalize" to="/careers"><strong>Learn More</strong> <v-icon>chevron_right</v-icon></v-btn> -->
            </div>

            <div>
              <v-img :src="images[0]" contain></v-img>
            </div>
          </v-flex>

          <v-flex xs12 sm8 md8 lg6 class="text-xs-left" v-else>
            <div class="mobileLastContainer">
              <h1 id="mobileWorkTitle">Work hard, play harder</h1>
              <v-img :src="images[0]" max-height="300" contain></v-img>
            </div>

            <div>
              <p>In addition to competitive salaries and a full range of comprehensive benefits, KSG offers benefits such as One-on-One Anniversary Lunch, Corporate Wellness Partnership with the Twin Cities Metro YMCA, Summer event, Monthly Company Lunch to Celebrate Associate Birthdays, Annual Movie Day and More!</p>
              <!-- <v-btn round outline color="#335091" class="text-capitalize mobileLearnMore" to="/careers"><strong>Learn More</strong> <v-icon>chevron_right</v-icon></v-btn> -->
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>

  <!-- Office locations -->
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 sm8 md8 lg6 xl5 class="centered-work">
        <h1 class="working-title">Where we Work</h1>

        <!-- <div :class="{ locationsContainer: !mobile }"> -->
        <div :class="{ locationsContainer: !mobile }">
          <div class="text-xs-left">
            <v-img
              :src="locationMN"
              contain
              class="locationImg"
            >
            </v-img>
            <h2 class="location-title">Minneapolis-St.Paul, MN</h2>

            <ul>
              <li class="list-margin">Cheer on our many professional sports teams including the Vikings (football), Twins (baseball), Wild (hockey), Timberwolves (men's basketball), Minnesota United FC (soccer) and Lynx (women's basketball)</li>
              <li class="list-margin">Bike the more than 200 miles of trails</li>
              <li class="list-margin">Explore the many acres of State and National Parks</li>
              <li class="list-margin">Enroll your kids in the nationally ranked school districts in the Twin Cities metro</li>
              <li class="list-margin">Walk around, swim in, canoe or kayak one of the many lakes</li>
              <li>Shop at the Mall of America, the biggest indoor retail mall in the US, that boasts an indoor amusement park and an aquarium</li>
            </ul>
          </div>

          <!-- <div class="text-xs-left">
            <v-img
              :src="locationVAN"
              contain
              class="locationImg"
            >
            </v-img>
            <h2 class="location-title">Vancouver, BC Canada</h2>

            <ul>
              <li class="list-margin">Check out the thriving art, theatre, and music scenes</li>
              <li class="list-margin">Eat at one of the many acclaimed restaurants and cafes (well-known as a foodie city)</li>
              <li class="list-margin">Surround yourself with the beauty of the Pacific Ocean to the west and Canadian Rockies to the east</li>
              <li class="list-margin">Hike the dozens of beautiful trails within an hour of the city</li>
              <li class="list-margin">Ski and snowboard at the nearby world-renowed ski resorts</li>
              <li class="list-margin">Discover Stanley Park and Seawall, Lonsdale Quay, Granville Island, Gastown and the many other stunning Vancouver sites</li>
              <li>Join the crowds in supporting the Canucks (hockey) and Whitecaps (soccer)</li>
            </ul>
          </div> -->
        </div>
      </v-flex>
    </v-layout>
  </v-container>

  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-btn to="/careers" round outline large color="#04307a" class="text-capitalize">
          <strong class="contact-button">Open Positions</strong> <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1
    }
  },
  data () {
    return {
      workPhoto: require('../assets/careers/WorkingAtKSG/Team_Working.png'),
      iconTest: require('../assets/careers/WorkingAtKSG/Icon_TestingFacility.png'),
      iconCompensation: require('../assets/careers/WorkingAtKSG/Icon_Compensation.png'),
      iconTools: require('../assets/careers/WorkingAtKSG/Icon_RightTools.png'),
      iconTeam: require('../assets/careers/WorkingAtKSG/Icon_StrongTeam.png'),
      iconHours: require('../assets/careers/WorkingAtKSG/Icon_FlexibleHours.png'),
      iconCulture: require('../assets/careers/WorkingAtKSG/Icon_CompanyCulture.png'),
      iconWellness: require('../assets/careers/WorkingAtKSG/Icon_EmployeeWellness.png'),
      iconSnacks: require('../assets/careers/WorkingAtKSG/Icon_FreeSnacks.png'),
      locationMN: require('../assets/careers/WorkingAtKSG/Location_Minneapolis.png'),
      locationVAN: require('../assets/careers/WorkingAtKSG/Location_Vancouver.png'),
      images: [
        require('../assets/careers/CompanyPhoto_Collage.png')
      ],
      currentCard: 0,
      employees: [
        // {
        //   name: 'Rachel',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Rachel_R_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Rachel_R.png'),
        //   quote: 'KSG is home to a team of intelligent, creative, and motivated people.  Because we work in an environment that fosters those traits, together we are able to innovate, to look beyond the boundaries of our objective toward what is possible.  Growth is at the heart of what we do: personal growth contributes to the collective, and together that growth contributes to the success of the company.'
        // },
        // {
        //   name: 'Chris',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Chris_R_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Chris_R.png'),
        //   quote: 'KSG puts great effort toward giving their artist the best tools, both software and hardware, which allows us to freely create the most engaging art that we can. KSG also strives to create a fun and inclusive environment that I truly appreciate.'
        // },
        {
          name: 'Anna',
          role: 'Executive Assistant',
          image: require('../assets/careers/AssociatePhotos/Anna_W_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Anna_W.png'),
          quote: 'I really appreciate how much KSG cares about its associates.  From the incredible healthcare coverage, and flexible work hours, to the ability to take on reach projects and new endeavors, I feel like I am part of a family that encourages and supports me in all aspects. It is great being able to stretch my wings in a company that wants to see me succeed!'
        },
        {
          name: 'Tyson',
          role: 'Producer',
          image: require('../assets/careers/AssociatePhotos/Tyson_T_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Tyson_T.png'),
          quote: 'I enjoy working in KSG’s laid-back, creative environment and collaborating with my co-workers every day. I also appreciate the work/home life balance KSG offers.'
        },
        // {
        //   name: 'Christian',
        //   role: 'Software Engineer',
        //   image: require('../assets/careers/AssociatePhotos/Christian_B_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Christian_B.png'),
        //   quote: 'KSG hosts fun and engaging events for associates all throughout the year. These serve as excellent team-building opportunities, and help to propagate an open and inclusive culture around the office, both socially and professionally.'
        // },
        {
          name: 'Nick',
          role: 'Mathematician',
          image: require('../assets/careers/AssociatePhotos/Nick_C_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Nick_C.png'),
          quote: 'The positive environment at King Show Games fosters opportunities to explore innovative solutions to unique problems.'
        },
        // {
        //   name: 'Lindsay',
        //   role: 'Project Management',
        //   image: require('../assets/careers/AssociatePhotos/Lindsay_B_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Lindsay_B.png'),
        //   quote: 'KSG provides a great balance of laid back and professional. They offer top of the line tools for professional success as well as opportunities to partake in events with coworkers. Associates know when to focus and work hard and also when to have fun, which makes coming to work enjoyable and rewarding.'
        // },
        {
          name: 'Tony',
          role: 'Software Engineer',
          image: require('../assets/careers/AssociatePhotos/Tony_G_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Tony_G.png'),
          quote: 'KSG is a special place to work for a few reasons. One is the level at which they value associates. KSG routinely goes above and beyond when investing in associate satisfaction - everything from work space and tool upgrades to complete extras like company events, refreshments, and gifts. The highly casual work environment and flex-hours scheduling combine to produce a very pleasant atmosphere that is accommodating of life outside work.'
        },
        {
          name: 'Kay',
          role: 'Artist',
          image: require('../assets/careers/AssociatePhotos/Kay_M_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Kay_M.png'),
          quote: 'Working for KSG has been ideal for my goals as a professional artist.  At KSG we are provided with industry standard tools that every digital artist dreams of working with. While the technology is great, I most appreciate the extra effort to give associates a healthy and flexible environment by providing adjustable height desks, free snacks, flex time, and great benefits. \xa0I find the work-life balance is perfect for my lifestyle and I enjoy coming to work every day!'
        },
        // {
        //   name: 'Chris "Lutz"',
        //   role: 'Software Engineer',
        //   image: require('../assets/careers/AssociatePhotos/Chris_K_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Chris_K.png'),
        //   quote: 'I enjoy the laid-back atmosphere, like casually talking to your boss, or the informal dress code, but everyone is still dedicated to doing their job seriously. \xa0I also enjoy the various small benefits, like the snacks provided, the flex-hours, and the small events like Pi Day.'
        // },
        // {
        //   name: 'Jesse',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Jesse_J_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Jesse_J.png'),
        //   quote: 'King Show Games has assembled an incredible team of emerging talent and experienced professionals who all share the same goal…making cutting edge games. It is humbling to be a part of such a talented group of people. Cliché, but our company really is one big family.'
        // },
        // {
        //   name: 'Carmen',
        //   role: 'Game Support Technician',
        //   image: require('../assets/careers/AssociatePhotos/Carmen_S_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Carmen_S.png'),
        //   quote: 'KSG and KSG associates care about what matters most to me, which is my son. \xa0They always check in with me about him and they love seeing him, when I bring him by. \xa0They offer paternity and maternity leave, because they care about the time you get with your families and that is why I love working for KSG.'
        // },
        // {
        //   name: 'Stefan',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Stefan_F_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Stefan_F.png'),
        //   quote: 'Every month we have an awesome lunch where we are able to celebrate coworkers who are having their birthday. It’s a great way to meet coworkers you don’t know well, catch up with old friends and try out new places in the surrounding area!'
        // },
        // {
        //   name: 'Parisa',
        //   role: 'Technical Artist',
        //   image: require('../assets/careers/AssociatePhotos/Parisa_N_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Parisa_N.png'),
        //   quote: 'I’m fond of KSG’s casual work environment. I also appreciate the fact that the company values its associates by providing great benefits and fun work activities. As a Technical Artist, I enjoy my position because it challenges me, and I learn something new almost every day.'
        // },
        // {
        //   name: 'Jobin',
        //   role: 'Software Engineer',
        //   image: require('../assets/careers/AssociatePhotos/Jobin_J_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Jobin_J.png'),
        //   quote: 'I enjoy working at KSG because it helps me improve my skills, and it doesn\'t feel like \'work\'. \xa0My co-workers are always keen to work with me to make things happen.'
        // },
        {
          name: 'Steve',
          role: 'IT and Infrastructure Manager',
          image: require('../assets/careers/AssociatePhotos/Steve_F_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Steve_F.png'),
          quote: 'KSG goes well above and beyond most organizations in sponsoring fun and frequent events that are excellent social settings to get to know everyone and connect beyond a just-a-coworker level. I’ve enjoyed getting to know people while racing a go-cart, laughing along with them at a movie, swinging a golf club at a driving range or enjoying a tasty meal to celebrate someone’s birthday.'
        },
        // {
        //   name: 'Amanda',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Amanda_R_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Amanda_R.png'),
        //   quote: 'The #1 thing I appreciate about KSG is the community: it’s filled with warm people who are approachable and easy to work with. \xa0The building is always kept clean, and there are nice big windows in the offices that let a lot of light in. \xa0It’s a company that’s always striving to do better; to learn and move forwards.'
        // },
        {
          name: 'Anna',
          role: 'Project Management',
          image: require('../assets/careers/AssociatePhotos/Anna_S_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Anna_S.png'),
          quote: 'The management really cares about the team, as evidenced by our many fun events and the resources spent to equip us to do our jobs to the best of our ability.'
        },
        // {
        //   name: 'Quinn',
        //   role: 'Technical Artist',
        //   image: require('../assets/careers/AssociatePhotos/Quinn_VM_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Quinn_VM.png'),
        //   quote: 'One of the reasons I enjoy working at KSG include the multiple social events that are organized by the company. \xa0The people I work with are extremely helpful and fun to talk to as many of us share similar interests.'
        // },
        {
          name: 'Grant',
          role: 'Software Engineer',
          image: require('../assets/careers/AssociatePhotos/Grant_B_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Grant_B.png'),
          quote: 'KSG has a fast paced work environment that pushes me to improve and expand upon my skillsets. \xa0Although the work is fun and rewarding, it’s the people that make it enjoyable to come to work every day.'
        },
        // {
        //   name: 'Molly',
        //   role: 'Game Support Technician',
        //   image: require('../assets/careers/AssociatePhotos/Molly_M_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Molly_M.png'),
        //   quote: 'I\'ve made a lot of new friends since working here. \xa0I like how open and inviting KSG associates are. \xa0It\'s really fun to hang out with them at the yearly events!'
        // },
        // {
        //   name: 'Kelsey',
        //   role: 'Artist',
        //   image: require('../assets/careers/AssociatePhotos/Kelsey_G_Circle.png'),
        //   imageSquare: require('../assets/careers/AssociatePhotos/Kelsey_G.png'),
        //   quote: 'The things I enjoy about working with KSG is the great people and great ideas that come out of our combined efforts. \xa0Working together to meet challenges head on and push the limits to make great games is always exciting!'
        // },
        {
          name: 'Michelle',
          role: 'VP of Talent',
          image: require('../assets/careers/AssociatePhotos/Michelle_D_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Michelle_D.png'),
          quote: 'I appreciate the respect and support shown for what each of us brings to the table. \xa0Our people are caring, smart and very passionate about their work; the outcomes of this unique combination are really special. \xa0We truly embody our stated company beliefs: Think Big, Be Frank, Fight Hard and After the Call, Move as a Team!'
        },
        {
          name: 'Reuben',
          role: 'Sound Designer',
          image: require('../assets/careers/AssociatePhotos/Reuben_T_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Reuben_T.png'),
          quote: 'The culture at KSG is great, we make fun games and I really enjoy working with this very talented team.'
        },
        {
          name: 'Andrew',
          role: 'Technical Artist',
          image: require('../assets/careers/AssociatePhotos/Andrew_C_Circle.png'),
          imageSquare: require('../assets/careers/AssociatePhotos/Andrew_C.png'),
          quote: 'One thing I really appreciate working for KSG, is the independence afforded the associates. \xa0The collaborative and creative ways you are naturally encouraged to solve problems and meet deadlines affords itself to an energized environment.'
        }
      ]
    }
  },
  methods: {
    carouselLeftClick () {
      if (this.currentCard === 0) {
        this.currentCard = this.employees.length - 1
      } else {
        this.currentCard -= 1
      }
    },
    carouselRightClick () {
      if (this.currentCard === this.employees.length - 1) {
        this.currentCard = 0
      } else {
        this.currentCard += 1
      }
    }
  }
}
</script>

<style lang="css" scoped>
.descriptionContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  align-items: center;
}

.working-title {
  font-size: 2.6rem;
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  color: #04307a;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.items-container {
  background-color: rgba(246, 130, 31, 0.2);
}

.inner-items-container {
  display: flex;
}

.orderItemsContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 1rem;
  grid-column-gap: 2rem;
}

.item-container {
  display: grid;
  grid-template-columns: 25% 1fr;
  grid-gap: 15px;
}

.item-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.5rem;
  color: #04307a;
}

.locationsContainer {
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3rem; */
  display: flex;
  flex-direction: column;
  width: 50%;
}

.location-title {
  margin: 1rem;
  font-size: 1.7rem;
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  color: #04307a;
  line-height: 1.15;
}

ul {
  list-style: none;
}

ul li::before {
  content: "\2022";
  color: #F38120;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  font-weight: bold;
}

.list-margin {
  margin-bottom: 1rem;
}

.contact-button {
  font-size: 1.5rem;
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
}

.locationImg {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.career-title {
  font-family: museo-slab, serif;
  font-weight: 700;
  font-size: 30px;
  color: #f6821f;
  letter-spacing: -2px;
}

.employee-container {
  display: grid;
  grid-template-columns: 40% 1fr;
  grid-gap: 1rem;
}

.employee-quotes {
  display: flex;
  justify-content: space-between;
  /* originally center */
  flex-direction: column;
}

.quote-style {
  line-height: 1.15;
  margin: 0 1rem;
}

.name-color {
  color: #335091;
  margin: 0 1rem;
}

.role-color {
  color: #5677c3 !important;
  font-size: 15px;
}

.carousel-container {
  display: flex;
  align-items: center;
  padding: 0;
}

#carouselLeft:hover, #carouselRight:hover {
  color: rgba(0,0,0,0.3)
}

.lastContainer {
  display: grid;
  grid-template-columns: 60% 40%;
  margin-top: 1rem;
  grid-gap: 2rem;
}

.mobileLastContainer {
  display: grid;
  grid-template-columns: 40% 60%;
  align-items: end;
}

#workTitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 4rem;
  color: #335091;
  display: inline-block;
  line-height: 90%;
  margin-bottom: 2rem;
}

#mobileWorkTitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.9rem;
  color: #335091;
  display: inline-block;
  line-height: 100%;
  margin-bottom: 1rem;
}

.centered-work {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.carouselDirection {
  z-index: 10;
  position: absolute;
  margin-left: -1rem;
  /* top: 50%; */
  margin-top: 5rem;
  left: 0;
  opacity: 0.4;
}

.carouselDirection:hover {
  opacity: 1;
}

.carouselDirectionRight {
  z-index: 10;
  position: absolute;
  margin-right: -1rem;
  /* top: 50%; */
  margin-top: 5rem;
  right: 0;
  opacity: 0.4;
}

.carouselDirectionRight:hover {
  opacity: 1;
}

.mobileLearnMore {
  margin: 0;
}
</style>
